import { useDigitalTrapsStore } from '@features/regional-overview/digital-traps/digital-traps.zustand';
import type { AssetGroup } from 'querys/regional-overview/regional-overview.query.models';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { createNetworkTableColumns, transformGroupedFeaturesToNetworkTraps } from './network-management.utils';
import { useNetworkManagementStore } from './network-management.zustand';

export const useNetworkManagementData = () => {
  const [t] = useTranslation();
  const trapGroups = useDigitalTrapsStore(state => state.trapGroups);
  const isLoading = useDigitalTrapsStore(state => state.isLoading);
  const { setEditingGroup } = useNetworkManagementStore();

  const handleGroupTitleEdit = useCallback(
    (group: AssetGroup) => {
      setEditingGroup(group);
    },
    [setEditingGroup]
  );

  const networks = useMemo(() => {
    if (trapGroups.length === 0) {
      return [];
    }

    const dynamicColumns = createNetworkTableColumns(t);
    const processedTrapGroups = transformGroupedFeaturesToNetworkTraps({
      trapGroups,
      dynamicColumns,
      onGroupTitleEdit: handleGroupTitleEdit
    });

    return processedTrapGroups;
  }, [trapGroups, handleGroupTitleEdit, t]);

  return { networks, isLoading };
};
